import "./src/styles/preflight.css"
import "./src/styles/global.css"

const { wrapPageElement } = require("utils/wrap-page-element")

export { wrapPageElement }
